/* @flow */
import * as React from "react";
import {
  withColorsProvider,
  type ColorSet,
} from "nx-components/ColorsProvider";
import DOMEventListener from "nexia_mobile/components/DOMEventListener";

type Props = {
  target: HTMLElement | void,
  disabled?: ?boolean,
  dragThreshold: number,
  activationThreshold: number,
  onActivate?: ?() => void,
  colors: ColorSet,
};

type State = {
  amountPulled: number,
};

class PullToRefreshLabelBar extends React.Component<Props, State> {
  state = {
    amountPulled: 0,
  };

  _dragging = false;
  _shouldActivate = false;
  _startY = null;

  _onDown = () => {
    if (this.props.disabled) {
      return;
    }
    this._dragging = true;
  };

  _onDrag = (event: TouchEvent) => {
    const { target, disabled, activationThreshold, dragThreshold } = this.props;

    if (disabled || !this._dragging || target == null || target.scrollTop > 0) {
      return;
    }

    let touch = event.touches[0];
    if (this._startY === null) {
      this._startY = touch.pageY;
    }
    let delta = touch.pageY - this._startY;

    if (delta < 0) {
      return;
    }

    let amountPulled;
    if (delta >= activationThreshold + dragThreshold) {
      this._shouldActivate = true;
      amountPulled = 1;
    } else if (delta >= dragThreshold) {
      this._shouldActivate = false;
      amountPulled = (delta - dragThreshold) / activationThreshold;
    } else {
      this._shouldActivate = false;
      amountPulled = 0;
    }

    this.setState({ amountPulled });
  };

  _onUp = () => {
    const { target, disabled, onActivate } = this.props;

    if (disabled || target == null) {
      return;
    }
    this._startY = null;
    this._dragging = false;
    this.setState({ amountPulled: 0 });

    if (this._shouldActivate) {
      this._shouldActivate = false;

      if (
        // Don't activate if the user pulled down enough to activate but
        // then scrolled down the page, because they might have intended to
        // cancel the pull-to-refresh by going back up.
        target.scrollTop <= 0 &&
        onActivate
      ) {
        onActivate();
      }
    }
  };

  render() {
    const { target, colors } = this.props;
    const { amountPulled } = this.state;

    const styles = {
      // TODO: These styles don't extend past the safe area on iPhone X. They are
      // never rendered on that device, but future Android notched devices will have
      // this. Replace this component with a better-looking alternative before then.
      bar: {
        pointerEvents: "none",
        position: "absolute",
        width: "100%",
        background: colors.IMPORTANT,
        color: colors.PRIMARY_TEXT,
        textAlign: "center",
        textTransform: "uppercase",
        fontSize: "0.8em",
        padding: "0.5em",
        zIndex: "1",
      },
    };

    return (
      <div
        data-component-name="PullToRefreshLabelBar"
        style={{
          ...styles.bar,
          opacity: amountPulled,
        }}
      >
        <DOMEventListener
          target={target}
          eventName="touchstart"
          handler={this._onDown}
        />
        <DOMEventListener
          target={target}
          eventName="touchmove"
          handler={this._onDrag}
        />
        <DOMEventListener
          target={target}
          eventName="touchend"
          handler={this._onUp}
        />
        {amountPulled === 1 ? "Release to refresh" : "Pull to refresh"}
      </div>
    );
  }
}

export default withColorsProvider(PullToRefreshLabelBar);



// WEBPACK FOOTER //
// ./src/components/PullToRefresh/PullToRefreshLabelBar.jsx